<template>
  <picture :class="containerClass" @click="$emit('click')">
    <source v-if="avifSrc" :srcset="avifSrc" :sizes="sizes || null" type="image/avif" />
    <source v-if="webpSrc" :srcset="webpSrc" :sizes="sizes || null" type="image/webp" />
    <img
      :src="src"
      :alt="alt"
      :loading="loading"
      :class="imgClass"
      :width="width"
      :height="height"
      :fetchpriority="fetchpriority"
      decoding="async"
      :style="computedStyle"
      :sizes="sizes || null"
      @load="onLoad"
      @error="onError"
    />
  </picture>
</template>

<script>
export default {
  name: 'ProgressiveImage',
  props: {
    src: {
      type: String,
      required: true,
    },
    avif: {
      type: String,
      default: '',
    },
    webp: {
      type: String,
      default: '',
    },
    alt: {
      type: String,
      default: '',
    },
    imgClass: {
      type: String,
      default: '',
    },
    containerClass: {
      type: String,
      default: '',
    },
    width: {
      type: [String, Number],
      default: '',
    },
    height: {
      type: [String, Number],
      default: '',
    },
    loading: {
      type: String,
      default: 'lazy',
    },
    fetchpriority: {
      type: String,
      default: 'auto',
    },
    aspectRatio: {
      type: String,
      default: '', // 比例: '16/9' 或者 '400/270'
    },
    sizes: {
      type: String,
      default: '', // 参考: '(max-width: 768px) 100vw, 60rem'
    },
    noFade: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loaded: false,
    };
  },
  computed: {
    avifSrc() {
      return this.avif;
    },
    webpSrc() {
      return this.webp;
    },
    computedStyle() {
      if (this.noFade) return {};
      const base = this.aspectRatio ? { aspectRatio: this.aspectRatio } : {};
      return { ...base, opacity: this.loaded ? 1 : 0, transition: 'opacity 0.3s ease' };
    },
  },
  methods: {
    onLoad() {
      this.loaded = true;
      this.$emit('load');
    },
    onError() {
      this.loaded = true; // 失败也显示占位，避免一直空白
      this.$emit('error');
    },
  },
};
</script>
